import { render } from "./Landing.vue?vue&type=template&id=7a42e100"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=7a42e100&lang=css"

import exportComponent from "C:\\ami-website\\www-restore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__